import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DnvBasemap } from 'dnv-lib';

@Injectable()
export class BasemapsService {

  headers: any;
  error: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  readonly basemapUrl = 'api/';

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getBasemaps(): Observable<DnvBasemap[]> {
    return this.httpClient
      .get<DnvBasemap[]>(this.basemapUrl + 'basemap', this.httpOptions);
  }
}

